function cov_1nkkznzbzc() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Minus.tsx";
  var hash = "7004166f4eb902ade9c5ed2177195245eb7a76a2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Minus.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7004166f4eb902ade9c5ed2177195245eb7a76a2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1nkkznzbzc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1nkkznzbzc();
var Icon = (cov_1nkkznzbzc().s[0]++, {
  name: 'minus',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M6.25 12.7499C6.0375 12.7499 5.85938 12.678 5.71563 12.5342C5.57188 12.3904 5.5 12.2122 5.5 11.9996C5.5 11.787 5.57188 11.609 5.71563 11.4654C5.85938 11.3218 6.0375 11.25 6.25 11.25H17.75C17.9625 11.25 18.1406 11.3219 18.2843 11.4657C18.4281 11.6095 18.5 11.7877 18.5 12.0003C18.5 12.2129 18.4281 12.391 18.2843 12.5346C18.1406 12.6782 17.9625 12.7499 17.75 12.7499H6.25Z\" fill=\"currentColor\"/>"
});
export default Icon;